<template>
    <div class="grid">
        <div class="image">
            <ResultsPractitionerImage :result="result" />
        </div>
        <div>
            <ResultsPractitionerHeader :result="result" :rank="rank" />
            <ResultsNetworkBannerContainer :result="result" :rank="rank"/>
            <ResultsPractitionerInfo :result="result" :rank="rank"/>
        </div>
    </div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const toggle = ref(false)

</script>

<style scoped lang="scss">

    .grid {
        display: grid;
        grid-template-columns: auto 11fr;
        column-gap: var(--spacing-sm);
    }

</style>